import { Component, OnInit, OnDestroy, NgZone } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { AuthenticationService } from './authentication.service';
import { GoogleAnalyticsService } from './services/google-analytics.service';
import { Router, NavigationEnd } from '@angular/router';
declare var ga: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isLoggedInSubscription: Subscription;
  isLoggedin: boolean;

  constructor(public authenticationService: AuthenticationService, private router: Router, public zone: NgZone, public googleAnalyticsService: GoogleAnalyticsService) {
    this.isLoggedInSubscription = this.authenticationService.getIsAuthenticated().subscribe((IsAuthenticated) => {
      this.zone.run(() => {
        if (IsAuthenticated && !this.authenticationService.isTokenExpired()) {
          this.isLoggedin = IsAuthenticated;
        }
      });
    });
    // GA Page Views
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
    this.authenticationService.getCreditPromotion();
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    if (this.isLoggedInSubscription) {
      this.isLoggedInSubscription.unsubscribe();
    }
  }

  submitGAEvent(eventCategory, eventAction, eventLabel) {
    this.googleAnalyticsService.emitEvent(eventCategory, eventAction, eventLabel, null);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/app.component.ts